import React, { useState } from 'react';
import {
    Box,
    Button,
    IconButton,
    TextField,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';

export default function AllergicIngredientsInput(props) {

    const { allergicIngredients, setAllergicIngredients } = props
    const [errors, setErrors] = useState({});

    const isValidInput = (value) => {
        const trimmed = value.trim();
        const safeRegex = /^[a-zA-Z0-9\s-]+$/;
        return trimmed.length > 0 && safeRegex.test(trimmed);
    };

    const handleInputChange = (index, value) => {
        const updated = [...allergicIngredients];
        updated[index] = value;
        setAllergicIngredients(updated);

        const validationErrors = { ...errors };
        if (!isValidInput(value)) {
            validationErrors[index] = 'Only letters, numbers, spaces, and hyphens allowed.';
        } else {
            delete validationErrors[index];
        }
        setErrors(validationErrors);
    };

    const handleAdd = () => {
        setAllergicIngredients([...allergicIngredients, '']);
    };

    const handleRemove = (index) => {
        const updated = allergicIngredients.filter((_, i) => i !== index);
        const updatedErrors = { ...errors };
        delete updatedErrors[index];
        setAllergicIngredients(updated);
        setErrors(updatedErrors);
    };

    return (
        <Box sx={{ p: 0, maxWidth: 600 }}>
            <div style={{ fontSize: '20px', fontFamily: 'Inter Medium', margin: '0px 0px 10px 0px' }}> Allergen Ingredients </div>
            <div style={{ width: '280px', fontSize: '12px', marginBottom: '20px' }}>
                Please list any ingredients in your product that may cause allergic reactions, such as nuts, dairy, gluten, soy, or shellfish. This helps ensure customer safety and allows them to make informed choices when ordering.
            </div>

            {allergicIngredients.map((ingredient, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <TextField
                        fullWidth
                        label={`Ingredient ${index + 1}`}
                        value={ingredient}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        error={!!errors[index]}
                        helperText={errors[index]}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{
                            sx: {
                                color: 'lightgray',
                                '&.Mui-focused': {
                                    color: 'rgb(255, 123, 41)',
                                },
                            },
                        }}
                        InputProps={{
                            sx: {
                                fontSize: '14px', // Set font size cleanly
                            },
                        }}
                        sx={{
                            width: '220px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 1,
                                backgroundColor: '#fff',
                                '& fieldset': {
                                    // borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgb(24, 20, 54)',
                                    // backgroundColor: '#f9f9f9',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'rgb(24, 20, 54)',
                                    // boxShadow: '0 0 0 2px rgba(24, 20, 54, 0.2)',
                                },
                            },
                        }}
                    />


                    {allergicIngredients.length > 1 && (
                        <IconButton
                            onClick={() => handleRemove(index)}
                            sx={{ ml: 1 }}
                            color="error"
                        >
                            <Delete />
                        </IconButton>
                    )}
                </Box>
            ))}

            <Button
                variant="contained"
                startIcon={<Add />}
                onClick={handleAdd}
                sx={{
                    mt: 1,
                    color: 'rgb(24, 20, 54)',
                    backgroundColor: '#EAEFEF',
                    '&:hover': {
                        backgroundColor: 'rgb(24, 20, 54)', // hover background
                        color: 'white', // optional: text color on hover
                    },
                }}
            >
                Allergen Ingredient
            </Button>

            {/* <Box mt={3}>
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                    Final sanitized ingredients array:
                </Typography>
                <Typography variant="body1">
                    {JSON.stringify(sanitizedIngredients)}
                </Typography>
            </Box> */}
        </Box >
    );
}